import { formatCurrency } from "../../utilities/formatCurrency";

export const RANGE_STATUS = {
  UNKNOWN: "unknown",
  WITHIN_RANGE: "within-range",
  OUT_OF_RANGE: "out-of-range",
};

export function deriveCheckoutSubmitState({
  isSubmitting,
  cartItemCount,
  rangeStatus,
  total,
}) {
  // console.log("deriveCheckoutSubmitState called with:", {
  //   isSubmitting,
  //   cartItemCount,
  //   rangeStatus,
  //   total,
  // });
  if (isSubmitting) {
    return {
      disabled: true,
      label: "Processing…",
    };
  }

  if (cartItemCount < 1) {
    return {
      disabled: true,
      label: "Your cart is empty",
    };
  }

  if (rangeStatus === RANGE_STATUS.OUT_OF_RANGE) {
    return {
      disabled: true,
      label: "Coming to your area soon!",
    };
  }

  if (rangeStatus === RANGE_STATUS.UNKNOWN) {
    return {
      disabled: false,
      label: `Pay ${formatCurrency(total)}`,
    };
  }

  return {
    disabled: false,
    label: `Pay ${formatCurrency(total)}`,
  };
}
